import React, { memo, useCallback, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { AcceptCustomerInviteSignContract } from 'src/components/customer/customer-sign-contract/AcceptCustomerInviteSignContract'

const AcceptCustomerInviteSignContractPageComponent = () => {
  const navigate = useNavigate()
  const params = useParams()

  const customerId = params?.customerId

  useEffect(() => {
    if (!customerId) {
      navigate(-1)
    }
  }, [customerId])

  const handleBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  if (!customerId) {
    return null
  }

  return (
    <div data-testid="mc-accept-customer-invite-sign-contract-page">
      <AcceptCustomerInviteSignContract customerId={customerId} onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          data-testid="mc-accept-customer-invite-back-btn"
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </div>
  )
}

export const AcceptCustomerInviteSignContractPage = memo(
  AcceptCustomerInviteSignContractPageComponent,
)
